import React from "react";
import { Box } from "@mui/material";



const ServicesTable = () => {
  return ( 

      <Box sx={{ marginTop:'32px'}}>
       service card here
      </Box>
  
   );
}
 
export default ServicesTable;